/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonial_Aubrey_WilliamsInputs */

const en_testimonial_aubrey_williams = /** @type {(inputs: Testimonial_Aubrey_WilliamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quite helpful for PDF reading University class readings`)
};

const es_testimonial_aubrey_williams = /** @type {(inputs: Testimonial_Aubrey_WilliamsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bastante útil para leer PDFs de lecturas universitarias`)
};

/**
* | output |
* | --- |
* | "Quite helpful for PDF reading University class readings" |
*
* @param {Testimonial_Aubrey_WilliamsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonial_aubrey_williams = /** @type {((inputs?: Testimonial_Aubrey_WilliamsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonial_Aubrey_WilliamsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonial_aubrey_williams(inputs)
	return en_testimonial_aubrey_williams(inputs)
});